import { TableCell as MuiTableCell, TableCellProps } from '@mui/material';

const TableCell = (props: TableCellProps) => {
  return <MuiTableCell {...props} sx={{ fontWeight: 'inherit' }} />;
};

export default TableCell;
